import React, { Component } from 'react';
import CarouselSlider from '../common/CarouselSlider';
import LoginHeader from '../common/LoginHeader';
import Button from '../common/Button';
import CustomScroll from 'react-custom-scroll';
import { appBasePath } from '../../constants/staticData';


export default class ResetEmailConfirmation extends Component {
    componentWillMount(){
      this.props.actions.clearComponentKey();
    }
    render() {
        return (
            <div className="container-fluid" id="wrapper">
                <LoginHeader headerTitle="Sign Up" />
                <CarouselSlider />
                <div className="col-md-6 col-sm-12 col-xs-12 pad0 grid-12">
                    <div className="customScroll">
                        <CustomScroll heightRelativeToParent="calc(100%)" allowOuterScroll={true}>
                            <div className="login-panel confirmed-reset-panel">
                                <div className="login-panel-header forget-panel-header">
                                    <h3 className="login-title">Confirmed</h3>
                                    <p className="note-text">
                                        Your password reset link has been sent to {this.props.authReducer ? this.props.authReducer.reset_email : ''}
                                    </p>
                                </div>
                                <div className="login-panel-footer confirmed-reset">
                                    <Button data-labelledby="Login in" btnType="red" btnSize="sm" fontSize={14} label="Log In" btnCallBack={(e) => { e.preventDefault(); this.props.router.push(`${appBasePath}/sign-in`) }} />
                                </div>
                            </div>
                        </CustomScroll>
                    </div>
                </div>
            </div>
        );
    }
}
